/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { IconButton, Grid, Divider, Typography } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import { CHAR_LIMITS } from 'config/constants';
import Link from 'next/link';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { numberFormatter } from 'core/utils';
import { NativePlatform } from 'core/models/platform';
import { numberWithCommas } from '@Common/handlers/helper';

interface IProps {
  value: number;
  limit: number;
  referrer: string;
  native?: NativePlatform | null;
}

const useStyles = makeStyles((theme) => ({
  limitExceeded: {
    color: '#ff0202',
    width: '100%  ',
  },
  blueText: {
    color: theme.specialColors.BLUE_COLOR,
    fontWeight: 600,
    cursor: 'pointer',
  },
}));

export default function CharacterSummaryWarning(props: IProps) {
  const classes = useStyles(props);
  const [showWarning, setVisibility] = useState(false);
  const charLimit = props.limit;
  const router = useRouter();
  const pathName = router.pathname;
  const referrer = props.referrer;

  let characterLimt;
  const user = useSelector((state: RootState) => state.user);
  if (pathName === '/summarize') {
    characterLimt = numberFormatter(CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_MEMBER);
    if (user?.isAuthenticated) {
      characterLimt = numberFormatter(CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_PREMIUM);
    }
  } else if (user?.isAuthenticated) {
    characterLimt = numberFormatter(CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_PREMIUM);
  } else characterLimt = CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_MEMBER;

  useEffect(() => {
    if (!showWarning && props.value > charLimit) {
      setVisibility(true);
    } else if (showWarning && props.value <= charLimit) {
      setVisibility(false);
    }
  }, [props.value]);

  return showWarning ? (
    <>
      <Grid
        container
        alignItems="center"
        className={classes.limitExceeded}
        justifyContent="space-between"
        style={{
          padding: '5px 15px 5px 15px',
          backgroundColor: '#FFDFDF',
          position: 'sticky',
          bottom: 50,
        }}
      >
        <Grid
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {user?.premium ? (
            <Typography style={{ fontSize: '11px' }}>
              Only {numberWithCommas(characterLimt)} words can be processed at one time.
            </Typography>
          ) : user?.isAuthenticated && props?.native ? (
            <Typography style={{ fontSize: '13px' }}>
              Visit Quillbot.com to get {characterLimt} words.
            </Typography>
          ) : (
            <Typography style={{ fontSize: '13px' }}>
              {user?.isAuthenticated ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`/premium?referrer=${referrer}${
                    props.native ? `&native=${props.native}` : ''
                  }`}
                >
                  <span
                    // className="login-offer-text green-text"
                    className={clsx(classes.blueText, 'login-offer-text')}
                  >
                    Buy Premium
                  </span>
                </a>
              ) : (
                <>
                  <Link
                    href={{
                      pathname: '/signup',
                      query: { referrer },
                    }}
                  >
                    <a className={clsx('login-offer-text', classes.blueText, 'pl-0')}>Sign Up</a>
                  </Link>
                </>
              )}{' '}
              for {characterLimt} words.
            </Typography>
          )}
        </Grid>
        <Grid item>
          <IconButton onClick={() => setVisibility(false)} style={{ padding: 0 }} size="large">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
    </>
  ) : null;
}
